import React, { PropTypes } from 'react';
import * as loader from 'loader'
import { components, consts, Actions, Translate, utils } from 'unity-core'
import { ModuleLoader } from 'components'
const { NavLink } = components
const { Routes } = consts
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, Row, Col, Thumbnail } from 'react-bootstrap'
import shortid from 'shortid'
import dbiaLogo from 'assets/dbia.png'
import ummLogo from 'assets/Umm.png'
import ubltLogo from 'assets/UBLT.png'
import uflowLogo from 'assets/UFLOW.png'
import usubLogo from 'assets/usub.jpg'
import utradeLogo from 'assets/utrade.png'
import imageUploaderLogo from 'assets/ImageUploader.png'
import userManagementLogo from 'assets/userManagement-icon.png'
const { accessControlUtils } = utils
import jwtDecode from 'jwt-decode'

const propTypes = {
  user: PropTypes.shape({
    permissions: PropTypes.object.isRequired
  }).isRequired,
  strings: PropTypes.object.isRequired
};
const defaultProps = {}

import betLogo from 'assets/UBET.png'

const getAppPerms = (user) => {
  const { token } = user;
  const details = jwtDecode(token)
  const { perms } = details;
  return perms;
}

const canAccessModule = (module, user, appPerms) => {
  return module.enabled && (
    (user.permissions[module.permission] && user.permissions[module.permission].app) ||
    (user.roles && _.find(user.roles, role => role.startsWith('USERMANAGER_SYSADMIN|'))) ||
    (appPerms && accessControlUtils.checkAccess(appPerms, `${module.permission}_APP`))
  )
};

//CHOOSE BETWEEN THE SET OF MODULES
export const ModuleSelect = ({ strings, user, actions, modules, lang }) => {

  const appPerms = getAppPerms(user);
  const enabledModules = _.map(_.keys(modules), x => (modules[x]))
  const groupedApps = _.chunk(_.filter(enabledModules, x =>
    canAccessModule(x, user, appPerms)
  ), 4)

  const appUBET = <Col key={'ubet'} xs={3} md={3} sm={3} lg={3}>
    <NavLink to={Routes.MODULES.UBET}>
      <Thumbnail src={betLogo} alt="BET Application">
        <h3 style={{ 'textAlign': 'center' }}>{strings.modules.UBET}<br /></h3>
      </Thumbnail>
    </NavLink>
  </Col>

  return (
    <Grid fluid>
      <Row>
        <Col sm={12} md={12}>
          <h3 style={{ 'textAlign': 'center', 'textDecoration': 'underline' }}><strong>{strings.title}</strong></h3>
        </Col>
      </Row>
      <Row className="slide-top-20">
        <Col sm={12} md={12} xs={12}>
          <Grid fluid>
            {
              _.map(groupedApps, (ga) => {
                return <Row key={shortid.generate()}>
                  {_.map(ga, m => {
                    if (m.external && m.externalApp)
                      return <Col xs={3} md={3} sm={3} lg={3} key={shortid.generate()}>
                        <a target="_blank" href={`/uappauth/app/${m.bundle}`}>
                          <Thumbnail src={dbiaLogo}>
                            <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                          </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'UBET')
                      return <Col xs={3} md={3} sm={3} lg={3} key='ubet'>
                        <a href={`/${m.path}`}><Thumbnail src={betLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'BLT')
                      return <Col xs={3} md={3} sm={3} lg={3} key='ublt'>
                        <a href={`/${m.path}`}><Thumbnail src={ubltLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'UFLOWQUANTUM')
                      return <Col xs={3} md={3} sm={3} lg={3} key='uflow'>
                        <a href={`/${m.path}`}><Thumbnail src={uflowLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'USERMANAGER')
                      return <Col xs={3} md={3} sm={3} lg={3} key='usrmng'>
                        <a href={`/${m.path}`}><Thumbnail src={userManagementLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'DUNSFILE')
                      return <Col xs={3} md={3} sm={3} lg={3} key='dunsfile'>
                        <a href={`/${m.path}`}><Thumbnail src={imageUploaderLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'SUBSCRIBER')
                      return <Col xs={3} md={3} sm={3} lg={3} key='usub'>
                        <a href={`/${m.path}`}><Thumbnail src={usubLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external && m.permission == 'TRADE')
                      return <Col xs={3} md={3} sm={3} lg={3} key='utrade'>
                        <a href={`/${m.path}`}><Thumbnail src={utradeLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    else if (m.external)
                      return <Col xs={3} md={3} sm={3} lg={3} key={shortid.generate()}>
                        <a href={`/${m.path}`}><Thumbnail src={ummLogo}>
                          <h3 style={{ 'textAlign': 'center' }}>{m.full_name ? m.full_name : m.name}</h3>
                        </Thumbnail></a>
                      </Col>
                    return <ModuleLoader key={shortid.generate()} bundle={m.bundle} r={x => {
                      if (x == null) return null
                      return <Col xs={3} md={3} sm={3} lg={3}>
                        <NavLink to={m.path}>
                          <Thumbnail src={x.Logo} alt={x.getDesc()}>
                            <h3 style={{ 'textAlign': 'center' }}>{x.getDesc()}</h3>
                          </Thumbnail>
                        </NavLink>
                      </Col>
                    }} />
                  })}
                </Row>
              })
            }
          </Grid>
        </Col>
      </Row>
    </Grid>
  )
}

ModuleSelect.propTypes = propTypes
ModuleSelect.defaultProps = defaultProps

const mapStateToProps = store => ({
  modules: store.app.modules,
  lang: store.user.lang
})

const decorators = _.flow([
  connect(mapStateToProps),
  Translate('Home')
])

export default decorators(ModuleSelect)
